<template>
  <div class="gameSignUp">
    <HeadBar title="我的资料" />
    <div class="gameSignUpInfo">
      <UserForm></UserForm>
    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import UserForm from "@/components/UserForm.vue";

  export default {
    name: "myInfo",
    components: {
      HeadBar,
      UserForm,
    },
    data() {
      return {
        username: "",
        userId: Cookies.get('USERID'),
      };
    },
    computed: {},
    mounted() { },
    methods: {},
  };
</script>
<style scope lang="less">
  /*遮罩层显示时body的样式*/
  .notScroll {
    overflow: hidden;
  }

  .game-card {
    background: #fff;
    margin-bottom: 10px;
    padding: 10px;
  }

  .gameSignUp {
    color: #333333;
    background: #efefef;
  }

  .signUpTitle {
    // border-bottom: 2px solid #ddd;
    padding: 10px 0;
    font-size: 16px;
    margin: 0;
  }

  .van-submit-bar {
    border-top: 1px solid #efefef;
  }

  .van-submit-bar__text {
    text-align: left;
  }

  .readAgree {
    margin-left: 15px;
    color: #1890ff;

    text-decoration: underline;
  }
</style>